/* eslint-disable */
// CommonJS on purpose: shared between the React app (src/components/Seo.js) and
// the Node build scripts (sitemap generation + prerendered head tags).
//
// Single source of truth for per-page SEO. Each entry maps the Spanish and
// English URLs to their title/description. `en: null` means no English version.

const PAGES = [
  {
    es: '/', en: '/en',
    esTitle: 'Tabia Group | Inversión y gestión de activos',
    enTitle: 'Tabia Group | Investment & Asset Management',
    esDesc: 'Grupo empresarial diversificado especializado en inversión, gestión de activos y asesoramiento estratégico en el sector inmobiliario e internacional.',
    enDesc: 'A diversified business group specializing in investment, asset management and strategic advisory across real estate and international markets.'
  },
  {
    es: '/grupo', en: '/en/grupo',
    esTitle: 'Grupo | Tabia Group',
    enTitle: 'Group | Tabia Group',
    esDesc: 'Conoce Tabia Group: nuestra historia, visión y trayectoria en inversión, gestión de activos y desarrollo de proyectos empresariales.',
    enDesc: 'Discover Tabia Group: our history, vision and track record in investment, asset management and business development.'
  },
  {
    es: '/que-hacemos', en: null,
    esTitle: 'Qué Hacemos | Tabia Group',
    esDesc: 'Descubre las áreas de actividad de Tabia Group: gestión, inversión inmobiliaria y creación de valor a largo plazo.'
  },
  {
    es: '/gestion', en: '/en/gestion',
    esTitle: 'Gestión | Tabia Group',
    enTitle: 'Management | Tabia Group',
    esDesc: 'Gestión integral de activos y proyectos: optimización de estructuras de inversión, control de riesgos y creación de valor.',
    enDesc: 'Comprehensive asset and project management: investment structuring, risk control and long-term value creation.'
  },
  {
    es: '/inmobiliaria', en: '/en/inmobiliaria',
    esTitle: 'Inmobiliaria | Tabia Group',
    enTitle: 'Real Estate | Tabia Group',
    esDesc: 'Inversión y desarrollo inmobiliario a nivel nacional e internacional: identificación de oportunidades y estructuración de operaciones.',
    enDesc: 'National and international real estate investment and development: sourcing opportunities and structuring transactions.'
  },
  {
    es: '/activos', en: '/en/activos',
    esTitle: 'Activos | Tabia Group',
    enTitle: 'Assets | Tabia Group',
    esDesc: 'Portfolio de activos de Tabia Group: proyectos inmobiliarios, hoteleros y empresariales en distintos mercados internacionales.',
    enDesc: 'Tabia Group asset portfolio: real estate, hospitality and business projects across international markets.'
  },
  {
    es: '/equipo', en: '/en/equipo',
    esTitle: 'Equipo | Tabia Group',
    enTitle: 'Team | Tabia Group',
    esDesc: 'Conoce al equipo directivo de Tabia Group: profesionales con amplia experiencia en inversión, finanzas, derecho y operaciones.',
    enDesc: 'Meet the Tabia Group leadership team: professionals with deep experience in investment, finance, law and operations.'
  },
  {
    es: '/medios', en: '/en/medios',
    esTitle: 'Medios | Tabia Group',
    enTitle: 'Media | Tabia Group',
    esDesc: 'Tabia Group en los medios: noticias, apariciones y contenidos sobre nuestra actividad y proyectos.',
    enDesc: 'Tabia Group in the media: news, features and content about our activity and projects.'
  },
  {
    es: '/contacto', en: '/en/contacto',
    esTitle: 'Contacto | Tabia Group',
    enTitle: 'Contact | Tabia Group',
    esDesc: 'Ponte en contacto con Tabia Group. Estaremos encantados de atender tus consultas sobre inversión y oportunidades de negocio.',
    enDesc: 'Get in touch with Tabia Group. We are happy to answer your questions about investment and business opportunities.'
  },
  {
    es: '/aviso-legal', en: '/en/legal-notice',
    esTitle: 'Aviso Legal | Tabia Group',
    enTitle: 'Legal Notice | Tabia Group',
    esDesc: 'Aviso legal de Tabia Group.',
    enDesc: 'Legal notice for Tabia Group.'
  },
  {
    es: '/politica-de-privacidad', en: '/en/privacy-policy',
    esTitle: 'Política de Privacidad | Tabia Group',
    enTitle: 'Privacy Policy | Tabia Group',
    esDesc: 'Política de privacidad de Tabia Group.',
    enDesc: 'Privacy policy for Tabia Group.'
  },
  {
    es: '/politica-de-cookies', en: '/en/cookie-policy',
    esTitle: 'Política de Cookies | Tabia Group',
    enTitle: 'Cookie Policy | Tabia Group',
    esDesc: 'Política de cookies de Tabia Group.',
    enDesc: 'Cookie policy for Tabia Group.'
  }
];

module.exports = { PAGES };
